import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Modal from '../Modal';
import { Modal as ReactModal, Button, Container, Row, Col } from 'react-bootstrap';
import { apiStartShootInstanceRequest, apiStopShootInstanceRequest } from 'Redux/actions/gear';
import errorIcon from 'Assets/icons/errorIcon.svg';
import { ModalFooter } from '../CommonStyles';

const InstanceLauncherPopup = ({
    instance,
    instanceNickName,
    orgName,
    ownerName,
    ownerEmail,
    curUserId,
    curUserName,
    curUserEmail,
    projectName,
    showInstanceLaunchModal,
    closeInstanceLaunchModal,
    props
  }) => {
  const dispatch = useDispatch();

  const auth = useSelector(state => state.auth);

  const [confirmStopModalShow, setConfirmStopModalShow] = useState(false);

  const onCloseBothModals = () => {
    setConfirmStopModalShow(false);
    closeInstanceLaunchModal();
  }

  const handleStartStopAction = () => {
    if (!(instance.status === "Running" || instance.status ===  "Pending")) {
      let requestData = {
        instance_air_id: instance.air_id,
        region_name: instance.region_name,
        instance_nick_name: instanceNickName,
        project_name: projectName,
        owner_email: ownerEmail,
        cur_user_id: curUserId,
        cur_user_email: curUserEmail,
        owner_name: ownerName,
        cur_user_name: curUserName,
        org_name: orgName,
        instance_status: 'STARTED',
      }
      dispatch(apiStartShootInstanceRequest(auth.token, requestData));
      closeInstanceLaunchModal();
    } else {
      setConfirmStopModalShow(true);
    }
  };

  const executeStopInstance = () => {
    let requestData = {
      instance_air_id: instance.air_id,
      region_name: instance.region_name,
      instance_nick_name: instanceNickName,
      project_name: projectName,
      org_name: orgName,
      owner_name: ownerName,
      owner_email: ownerEmail,
      cur_user_id: curUserId,
      cur_user_name: curUserName,
      cur_user_email: curUserEmail,
      instance_status: 'STOPPED',
    }
    dispatch(apiStopShootInstanceRequest(auth.token, requestData));
    onCloseBothModals();
  };

  const confirmStopModalFooter = (
    <ModalFooter>
      <Button onClick={() => setConfirmStopModalShow(false)} variant="light">
        No, Cancel
      </Button>
      <Button onClick={executeStopInstance} variant="danger">
        Yes, Stop
      </Button>
    </ModalFooter>
  );

  return (
    <>
      <ReactModal
        {...props}
        show={showInstanceLaunchModal}
        onHide={onCloseBothModals}
        backdrop="static"
        centered
      >
        <ReactModal.Header className="p-0" closeButton>
          <ReactModal.Title>
            EC2 Instance: {instance.name}
          </ReactModal.Title>
        </ReactModal.Header>

        <ReactModal.Body className="p-2">
            <Container>
              <Row>
                <Col>Organization: {instance.organization}</Col>
              </Row>
              <Row>
                <Col>IP address: {instance.public_ip}</Col>
              </Row>
              <Row>
                <Col>Status: {instance.status}</Col>
              </Row>
              <Row>
                <Col>Region: {instance.region_name}</Col>
              </Row>
              <Row>
                <Col>Up time: {instance.up_time}</Col>
              </Row>
            </Container>
        </ReactModal.Body>

        <ReactModal.Footer className="d-flex justify-content-center p-0">
          <Button
            onClick={handleStartStopAction}
          >
            {(instance.status === 'Running' || instance.status ===  "Pending") ? 'Stop Instance' : 'Start Instance'}
          </Button>
        </ReactModal.Footer>
      </ReactModal>

      <Modal
        show={confirmStopModalShow}
        onHide={() => setConfirmStopModalShow(false)}
        icon={errorIcon}
        title={'Stop the Instance'}
        body={'Are you sure you want to shut down this EC2 instance?'}
        footer={confirmStopModalFooter}
      />
    </>

  );
};

export default InstanceLauncherPopup;